import { module } from "angular";
import { StepIconComponent } from "./StepIconComponent";

module("mmGui").component("mmStepIcon", new StepIconComponent());
